import * as Yup from 'yup';

import i18n from '@/i18n';
import { CustomAttributeTemplate, CustomAttributeValue } from '@/types';

const selectRegexForObject = (
  object: CustomAttributeValue,
  customAttributeTemplates: CustomAttributeTemplate[]
) => {
  return (
    customAttributeTemplates.find((ct) => ct.id === object.customAttributeTemplateId)
      ?.validationRegex ?? ''
  );
};

export const dynamicValidationSchema = (customAttributeTemplates: CustomAttributeTemplate[]) => {
  const schemaFields = {
    name: Yup.string()
      .required(i18n.t('nameRequired', { ns: 'common' }))
      .min(2, i18n.t('nameMin', { ns: 'common' }))
      .max(35, i18n.t('nameMax', { ns: 'common' })),
    startDateAndTime: Yup.string()
      .required(i18n.t('startDateRequired', { ns: 'common' }))
      .nullable(),
    organizationId: Yup.number().moreThan(0, i18n.t('organizationRequired', { ns: 'common' })),
    contentDeadline: Yup.string()
      .required(i18n.t('contentDeadlineRequired', { ns: 'common' }))
      .nullable(),
    ceremonyTemplateId: Yup.number()
      .moreThan(0, i18n.t('ceremonyTemplateRequired', { ns: 'common' }))
      .nullable(),
    customAttributeValues: Yup.array().of(
      Yup.object().shape({
        value: Yup.string().test('regex-test', 'invalid', function (value) {
          const regexString = selectRegexForObject(this.parent, customAttributeTemplates);
          const regex = new RegExp(regexString);
          return regex.test(value ?? '');
        })
      })
    )
  };

  return Yup.object().shape(schemaFields);
};
